"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelTrendsOrder = exports.useTrendsOrders = exports.isTrendOrderTriggered = exports.isTrendOrderRunning = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const TrendAPI_1 = require("../../../apis/TrendAPI");
const interface_1 = require("../../../interface");
const TrendsOrdersPageLength = 10;
function fetchList(isHistory, params) {
    // 注意：活跃订单默认获取全部
    return isHistory ? (0, TrendAPI_1.getHistoryTrends)(params) : (0, TrendAPI_1.getActiveTrends)({ page_size: 100 });
}
const NullArray = [];
function isTrendOrderRunning(status) {
    return status === interface_1.TrendOrderStatus.prepare || status === interface_1.TrendOrderStatus.waiting || status === interface_1.TrendOrderStatus.running;
}
exports.isTrendOrderRunning = isTrendOrderRunning;
function isTrendOrderTriggered(order) {
    return order.status === interface_1.TrendOrderStatus.triggered;
}
exports.isTrendOrderTriggered = isTrendOrderTriggered;
/**获取画线下单 */
function useTrendsOrders(props, active = true) {
    const { isHistory = false, symbol, limit = TrendsOrdersPageLength, apiKey, observerWSOrders } = props;
    const lastPageCursor = (0, react_1.useRef)("");
    const [listData, setListData] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)();
    const [refreshing, setRefreshing] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [hasMore, setHasMore] = (0, react_1.useState)(true);
    const initSuccess = (0, react_1.useRef)(false);
    const loadingRef = (0, react_1.useRef)(false);
    const listDataRef = (0, react_1.useRef)(listData);
    listDataRef.current = listData;
    const refresh = (0, react_1.useCallback)(() => {
        if (loadingRef.current) {
            return;
        }
        setRefreshing(true);
        loadingRef.current = true;
        return fetchList(isHistory, {
            page_size: limit,
            symbol,
        }).subscribe({
            next: ({ items, next_page_token = "" }) => {
                const newData = items || [];
                setRefreshing(false);
                setError(null);
                setHasMore(newData.length >= limit);
                lastPageCursor.current = next_page_token;
                setListData(newData);
                loadingRef.current = false;
                initSuccess.current = true;
            },
            error: (error) => {
                setRefreshing(false);
                setError(error);
                setHasMore(false);
                loadingRef.current = false;
            },
        });
    }, [isHistory, limit, symbol]);
    const loadMore = (0, react_1.useCallback)(() => {
        if (!lastPageCursor.current || !hasMore || !listData.length || loadingRef.current) {
            return;
        }
        loadingRef.current = true;
        setLoading(true);
        return fetchList(isHistory, {
            page_token: lastPageCursor.current,
            page_size: limit,
            symbol,
        }).subscribe({
            next: ({ items, next_page_token = "" }) => {
                setError(null);
                const newData = items || [];
                setHasMore(newData.length >= limit);
                setListData((prevData) => {
                    return prevData.concat(newData);
                });
                loadingRef.current = false;
                lastPageCursor.current = next_page_token;
                setLoading(false);
            },
            error: (error) => {
                setHasMore(false);
                loadingRef.current = false;
                setLoading(false);
            },
        });
    }, [hasMore, isHistory, limit, listData.length, symbol]);
    // 历史订单，只依赖symbol；活跃订单只依赖active,调用接口必须确保apiKey存在
    const isApiKey = !!apiKey;
    /**当筛选参数发生变跟时，重新获取最新的数据 */
    (0, react_1.useEffect)(() => {
        if (initSuccess.current && !active && isApiKey) {
            return;
        }
        const sub = refresh();
        return () => {
            // 重置下相关的状态
            setLoading(false);
            setRefreshing(false);
            loadingRef.current = false;
            setError(null);
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isHistory ? symbol : active, isApiKey]);
    (0, react_1.useEffect)(() => {
        if (!apiKey) {
            setListData([]);
        }
    }, [apiKey, setListData]);
    // FIXME 目前后端推送的数据不全，需要再次
    const fetchOrderById = (0, react_1.useCallback)((orderId) => __awaiter(this, void 0, void 0, function* () {
        try {
            const newOrder = yield (0, rxjs_1.firstValueFrom)((0, TrendAPI_1.getTrendOrder)(orderId));
            if (!newOrder) {
                return;
            }
            setListData((origin) => {
                const newList = origin.slice(0);
                // 注意：这个地方是为了避免用户在这个时候进行了刷新的操作
                // 所以先确保当前列表中不具有这个订单，如果存在这个订单就把这个订单给移除掉
                const findIndex = newList.findIndex((it) => it.bu_order_id === newOrder.bu_order_id);
                if (findIndex !== -1) {
                    newList.splice(findIndex, 1);
                }
                newList.unshift(newOrder);
                return newList;
            });
        }
        catch (error) { }
    }), []);
    (0, react_1.useEffect)(() => {
        if (isHistory || !observerWSOrders) {
            return;
        }
        const unSub = observerWSOrders().subscribe({
            next: (order) => {
                const newList = listDataRef.current.slice(0);
                const index = newList.findIndex((item) => item.bu_order_id === order.bu_order_id);
                if (index >= 0) {
                    // find index and update it
                    if (!isTrendOrderRunning(order.status)) {
                        // remove item from array
                        newList.splice(index, 1);
                    }
                    else {
                        newList[index] = Object.assign({}, newList[index], order.bu_order_data);
                    }
                    setListData(newList);
                }
                else if (isTrendOrderRunning(order.status)) {
                    // 如果当前列表中不具有这个订单，则通过id从后端获取订单
                    fetchOrderById(order.bu_order_id);
                }
            },
        });
        return () => {
            unSub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, observerWSOrders]);
    const batchCancelOrders = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (isHistory || !listData.length) {
            // 取消订单失败
            return 0;
        }
        const splitList = listData.slice(0, 10).map((it) => (0, rxjs_1.firstValueFrom)((0, TrendAPI_1.closeTrendOrder)({
            bu_order_id: it.bu_order_id,
            reason_by: "",
        })));
        /**批量取消订单之后，从订单中移除该数据 */
        try {
            const results = yield Promise.allSettled(splitList);
            const orders = results.filter((it) => it.status === "fulfilled");
            const removedSet = new Set(orders.map((it) => it.value.bu_order_id));
            // 由于后端的推送会有很大的延迟，因此在这里直接从列表中立即删除已经被撤销的订单
            setListData((data) => data.filter((it) => !removedSet.has(it.bu_order_id)));
            return orders.length;
        }
        catch (error) {
            // something went wrong
        }
        return 0;
    }), [isHistory, listData]);
    const cancelOrder = (0, react_1.useCallback)((orderId) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield (0, rxjs_1.firstValueFrom)(cancelTrendsOrder(orderId));
            // 由于后端的推送会有很大的延迟，因此在这里直接从列表中立即删除已经被撤销的订单
            setListData((data) => data.filter((it) => it.bu_order_id !== orderId));
            return true;
        }
        catch (error) {
            // something went wrong
        }
        return false;
    }), []);
    const displayList = (0, react_1.useMemo)(() => {
        if (!apiKey) {
            return NullArray;
        }
        if (!isHistory && symbol) {
            return listData.filter((it) => it.symbol === symbol);
        }
        return listData;
    }, [apiKey, isHistory, listData, symbol]);
    return {
        /**是否正在刷新 */
        refreshing,
        /**刷新的函数 */
        refresh,
        loading,
        loadMore,
        hasMore,
        error,
        /**当前列表的数据 */
        listData: displayList,
        /**批量取消订单，该函数直接返回被成功取消的订单数量*/
        batchCancelOrders,
        /**取消单个订单，需要传入id */
        cancelOrder,
    };
}
exports.useTrendsOrders = useTrendsOrders;
function cancelTrendsOrder(orderId) {
    return (0, TrendAPI_1.closeTrendOrder)({
        bu_order_id: orderId,
        reason_by: "",
    });
}
exports.cancelTrendsOrder = cancelTrendsOrder;
